import {Routes} from '@angular/router';
import {HomeComponent} from './home.component';
import {AuthGuard} from '../core/security/auth-guard.service';

export const routes: Routes = [
  {
    path: 'home',
    canActivate: [AuthGuard],
    component: HomeComponent,
    data: {
      meta: {
        title: 'Home',
        override: true,
        description: 'Home Page'
      }
    }
  }
];
